export const api_key = `AIzaSyAwElRh57Tzj0OJJDr1VzLGXF1Xm6pcnUg`